import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Outlet, useLocation, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import StatusBar from './components/StatusBar';
import BottomNav from './components/BottomNav';
import Home from './pages/Home';
import Memory from './pages/Memory';
import MemoryDetail from './pages/MemoryDetail';
import MemoryAsk from './pages/MemoryAsk';
import Settings from './pages/Settings';
import RingLink from './pages/RingLink';
import Welcome from './pages/Welcome';

const Layout = () => {
  const location = useLocation();
  const hideNav =
    location.pathname === '/settings' ||
    location.pathname === '/ring/link' ||
    location.pathname === '/welcome';
  return (
    <div className="app-backdrop">
      <div className="phone font-sans-lp">
        <StatusBar />
        <div className="phone-scroll lp-scroll">
          <Outlet />
        </div>
        {!hideNav && <BottomNav />}
      </div>
    </div>
  );
};

// Root entry: show the Welcome screen on first open, then Home thereafter.
const RootGate = () => {
  if (!sessionStorage.getItem('lp_entered')) {
    return <Navigate to="/welcome" replace />;
  }
  return <Home />;
};

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/" element={<RootGate />} />
              <Route path="/memory" element={<Memory />} />
              <Route path="/memory/ask" element={<MemoryAsk />} />
              <Route path="/memory/:id" element={<MemoryDetail />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/ring/link" element={<RingLink />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
